import * as Routes from './routes.js'
export default Routes
